import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getDoctoresQueHanRecibidoPagos.php';

export default function getDoctoresQueHanRecibidoPagos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}